import React from 'react';
import { SocialPlatform } from '../../types/socialMediaPlanner';

interface PlatformIconProps {
  platform: string | SocialPlatform;
  size?: 'sm' | 'md' | 'lg'; // Small, Medium, Large
}

/**
 * Platform Icon Component
 * Renders consistent social media platform icons across the application
 */
const PlatformIcon: React.FC<PlatformIconProps> = ({ platform, size = 'md' }) => {
  // Determine sizing classes based on size prop
  const getSizeClasses = (): string => {
    switch (size) {
      case 'sm': return 'w-4 h-4 text-xs';
      case 'lg': return 'w-6 h-6 text-base';
      case 'md':
      default: return 'w-5 h-5 text-sm';
    }
  };

  const baseClasses = `flex items-center justify-center ${getSizeClasses()}`;

  // Render platform-specific icon
  switch (platform.toLowerCase()) {
    case 'facebook':
      return (
        <div className={`${baseClasses} text-blue-600`}>
          <span className="font-bold">f</span>
        </div>
      );
    case 'twitter':
    case 'x':
      return (
        <div className={`${baseClasses} text-blue-400`}>
          <span className="font-bold">t</span>
        </div>
      );
    case 'linkedin':
      return (
        <div className={`${baseClasses} text-blue-800`}>
          <span className="font-bold text-xs">in</span>
        </div>
      );
    case 'instagram':
      return (
        <div className={`${baseClasses} text-pink-500`}>
          <span className="font-bold">ig</span>
        </div>
      );
    case 'tiktok':
      return (
        <div className={`${baseClasses} text-black`}>
          <span className="font-bold">tk</span>
        </div>
      );
    case 'pinterest':
      return (
        <div className={`${baseClasses} text-red-600`}>
          <span className="font-bold">p</span>
        </div>
      );
    default:
      return (
        <div className={`${baseClasses} text-gray-500`}>
          <span className="font-bold">?</span>
        </div>
      );
  }
};

export default PlatformIcon;
